// ─────────────────────────────────────────────────
// Estilos compartidos
// ─────────────────────────────────────────────────
export const INPUT_S     = { width:"100%", padding:"9px 12px", background:"#1a1a1a", border:"1px solid #3a3a3a", borderRadius:"8px", color:"#e5e7eb", fontFamily:"Inter, sans-serif", fontSize:"0.875rem", outline:"none", boxSizing:"border-box" }
export const LABEL_S     = { display:"block", fontSize:"0.75rem", fontWeight:700, color:"#6b7280", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"5px" }
export const BTN_PRIMARY = { padding:"11px", background:"#3b82f6", border:"none", borderRadius:"8px", color:"white", fontFamily:"Inter, sans-serif", fontWeight:700, cursor:"pointer", fontSize:"0.875rem" }
export const BTN_GHOST   = { padding:"10px", background:"#1a1a1a", border:"1px solid #3a3a3a", borderRadius:"8px", color:"#9ca3af", fontFamily:"Inter, sans-serif", fontWeight:700, cursor:"pointer", fontSize:"0.875rem" }
export const BTN_DANGER  = { padding:"10px", background:"#3a1a1a", border:"1px solid #ef4444", borderRadius:"8px", color:"#ef4444", fontFamily:"Inter, sans-serif", fontWeight:700, cursor:"pointer", fontSize:"0.875rem" }

// ─────────────────────────────────────────────────
// Datos
// ─────────────────────────────────────────────────
export const PROVINCIAS = ["Buenos Aires","Córdoba","Santa Fe / Rosario","Mendoza","Tucumán","Salta","Neuquén","Río Negro / Bariloche","Entre Ríos","Corrientes","Jujuy","Otro"]
export const AEROLINEAS = ["Jet Smart","Aerolíneas Argentinas","GOL","LATAM","Flybondi","ARAJET","Copa Airlines","Sky Airline"]
export const CANALES    = ["Cliente directo","Martina","Cecilia","Sofia","Ariana","Daniela","Referido","Publicidad","Conocido","Grupo WhatsApp","Claudia","Flor","Fernando"]

// ─────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────
export function parsearFecha(str) {
  if (!str) return null
  if (typeof str === "object" && str.toDate) return str.toDate()
  const s = str.trim()
  // Formato DD/MM/YYYY
  if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(s)) {
    const [d,m,y] = s.split("/")
    return new Date(Number(y), Number(m)-1, Number(d))
  }
  // Formato YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y,m,d] = s.split("-")
    return new Date(Number(y), Number(m)-1, Number(d))
  }
  // Formato DD/MM/YY
  if (/^\d{1,2}\/\d{1,2}\/\d{2}$/.test(s)) {
    const [d,m,y] = s.split("/")
    return new Date(2000+Number(y), Number(m)-1, Number(d))
  }
  return null
}

export function formatFecha(str) {
  if (!str) return "—"
  try { return new Date(str).toLocaleDateString("es-AR") } catch { return str }
}

export function ptsCliente(c) {
  if (!c) return 0
  return (c.puntos_aporte||0)+(c.puntos_feedback||0)+(c.puntos_referidos||0)
        +(c.puntos_compra_ref||0)+(c.puntos_cumpleanos||0)-(c.puntos_usados||0)
}

export function urgenciaViaje(viaje) {
  const hoy = new Date(); hoy.setHours(0,0,0,0)
  const salida  = parsearFecha(viaje.fecha_salida)
  const regreso = parsearFecha(viaje.fecha_regreso)
  if (!salida) return "normal"
  const diasSalida  = Math.ceil((salida - hoy) / 86400000)
  const diasRegreso = regreso ? Math.ceil((regreso - hoy) / 86400000) : null
  if (diasSalida >= 0 && diasSalida <= 1)  return "hoy"
  if (diasRegreso !== null && diasRegreso >= 0 && diasRegreso <= 1) return "regreso-hoy"
  if (diasSalida >= 0 && diasSalida <= 7)  return "proximo"
  if (diasSalida < 0 && diasRegreso !== null && diasRegreso >= 0) return "en-viaje"
  return "normal"
}
